/**
 * @generated SignedSource<<7dfc9ee594b400f8b5c43163ad98b1d7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d

import type { ConcreteRequest } from 'relay-runtime';
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type useContentClassificationContentDataClassificationQuery$variables = {
  contentId: string;
  lowerCaseContentStatusArray?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery$data = {
  readonly singleContent: {
    readonly classificationLevelDetails: {
      readonly canManageSpaceSettings: boolean;
      readonly classificationControlSetting: string | null | undefined;
      readonly classificationLevel: {
        readonly color: string | null | undefined;
        readonly description: string | null | undefined;
        readonly guideline: string | null | undefined;
        readonly guidelineADF: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly status: string;
      } | null | undefined;
      readonly featureEnabled: boolean;
      readonly isReclassificationPermitted: boolean;
      readonly source: ClassificationLevelSource | null | undefined;
      readonly userOverrideSetting: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery = {
  response: useContentClassificationContentDataClassificationQuery$data;
  variables: useContentClassificationContentDataClassificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lowerCaseContentStatusArray"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "lowerCaseContentStatusArray"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentDataClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevel",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "guideline"
              },
              {
                "kind": "ScalarField",
                "name": "guidelineADF"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "color"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "featureEnabled"
          },
          {
            "kind": "ScalarField",
            "name": "source"
          },
          {
            "kind": "ScalarField",
            "name": "isReclassificationPermitted"
          },
          {
            "kind": "ScalarField",
            "name": "canManageSpaceSettings"
          },
          {
            "kind": "ScalarField",
            "name": "classificationControlSetting"
          },
          {
            "kind": "ScalarField",
            "name": "userOverrideSetting"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
    "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
    "metadata": {},
    "name": "useContentClassificationContentDataClassificationQuery",
    "operationKind": "query",
    "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
  }
};
})();

(node as any).hash = "e2a3c90b94181436fe0a32faafb92cf6";

export default node;
